import Layout from "@/components/ui/Layout";
import { useCurrency } from "@/contexts/CurrencyContext";
import ProductCard from "@/components/ui/ProductCard";

export default function ProductsBlock({ products = [] }) {
  const { currency, formatCurrency } = useCurrency();

  const productCards = (products ?? []).map((p) => {
    const v = p.product_variants?.[0];
    const rawImage = v?.images?.[0]?.url || p.images?.[0]?.url;
    const image = rawImage ? "" + rawImage : "/themes/printerwebshop/placeholder.webp";
    const basePrice = v?.base_price ?? null;

    return {
      id: p.id,
      title: p.name,
      image,
      href: "/" + p.slug,
      price: basePrice != null ? `${formatCurrency(basePrice)} ${currency?.symbol ?? "Ft"}` : null,
    };
  });

  const centerColumn = (
    <section>
      <div className="w-full mx-auto space-y-4">
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-6 2xl:grid-cols-8 gap-x-3 gap-y-6 sm:gap-x-6 sm:gap-y-6">
          {productCards.map((p) => (
            <ProductCard
              key={p.id}
              title={p.title}
              image={p.image}
              href={p.href}
              price={p.price}
            />
          ))}
        </div>
      </div>
    </section>
  );

  return <Layout center={centerColumn} />;
}
